<section class="dark">
    <div class="contained">
        <h1>Sink & Taps</h1>
        <div class="sub-head">
            No new kitchen is complete without a sink and some taps to go with it. Feel free to take
            your time and choose the items that are right for your new kitchen.
        </div>
    </div>
</section>
<component-product-category *ngIf="loaded" type="sinks-and-taps" [categories]="categories"></component-product-category>